var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm",class:_vm.value.class,staticStyle:{"font-size":"10px","width":"106px"},attrs:{"disabled":_vm.value.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[(_vm.value.icon)?_c('i',{class:_vm.value.icon}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.value.content)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }